/**
 * This file is auto-generated from useChatSubscriptionStart.loc.yaml
 * Do not edit this file directly. Edit the source file instead.
 */
export const renews = (lang, params) => {
    switch (lang) {
        case 'en':
            return ['renews ', params.date];
        case 'pl':
            return ['odnawia się ', params.date];
    }
};
//# sourceMappingURL=useChatSubscriptionStart.loc.js.map